import { fetchRecentIncidents } from "./fetch-incident";
import { renderIncidentFeed } from "./incident";
import { initSentry, openFeedback } from "./sentry";
import type { Incident } from "./types";

const DEFAULT_GRAFANA_URL =
  "https://status.romashov.tech/public-dashboards/682f41458ddb4bffa79cecc5432ddeb9/";

const DEFAULT_SENTRY_DSN =
  "https://322045f5a01c0bed2585912cbd5296e9@o164625.ingest.us.sentry.io/4507291211595776";

const banner = document.getElementById("incident-banner");
const iframe = document.getElementById("grafana-dashboard");
const feedbackOpen = document.getElementById("feedback-open");

if (!banner || !(iframe instanceof HTMLIFrameElement) || !feedbackOpen) {
  throw new Error("Status page markup is missing required elements");
}

iframe.src = withGrafanaLightTheme(
  import.meta.env.VITE_GRAFANA_IFRAME_URL || DEFAULT_GRAFANA_URL,
);
initSentry(import.meta.env.VITE_SENTRY_DSN || DEFAULT_SENTRY_DSN);

feedbackOpen.addEventListener("click", async () => {
  try {
    await openFeedback();
  } catch (error) {
    console.error("Failed to open feedback form", error);
  }
});

void loadIncidentFeed(banner);

async function loadIncidentFeed(container: HTMLElement): Promise<void> {
  const incidents: Incident[] = await fetchRecentIncidents();
  renderIncidentFeed(container, incidents);
}

function withGrafanaLightTheme(url: string): string {
  const parsed = new URL(url);
  parsed.searchParams.set("theme", "light");
  return parsed.toString();
}
